/**
 * The entity a fan-out subject belongs to: the concrete id segment of a
 * Morfi subject (`morfi.<domain>.<id>.…`). `null` when that segment is a
 * wildcard, so the subject is never viewport-gated.
 */
export function defaultSubjectGateId(subject: string): string | null {
  const id = subject.split('.')[2];
  if (id === undefined || id === '' || id === '*' || id === '>') return null;
  return id;
}
